export default {"src":"/_next/static/image/public/img/chart-bar.460841029df265cc20a51eb8dd9186af.svg","height":192,"width":192};